import React, { FunctionComponent } from 'react';

import classNames from 'classnames';

import styles from './team-card-due-scroll-navigation.less';

import {
  Tab,
  TabButton,
  TabButtonProps,
  TabIcon,
  TabList,
  TabRightChild,
  TabSection,
  TabText,
} from './tab';

interface CardCountProps {
  count: number;
  selected?: boolean;
}

const CardCount: FunctionComponent<CardCountProps> = ({
  count,
  selected,
  ...props
}) => {
  const countDisplay = count > 50 ? '50+' : `${count}`;

  return (
    <div
      className={classNames(styles.countContainer, {
        [styles.selected]: selected,
      })}
      {...props}
    >
      {countDisplay}
    </div>
  );
};

interface CardDueTabProps extends TabButtonProps, CardCountProps {
  tabText: string;
}

const CardDueTab: FunctionComponent<CardDueTabProps> = ({
  count,
  selected,
  tabText,
  ...props
}) => (
  <Tab>
    <TabButton
      className={styles.cardDueTabButton}
      selected={selected}
      small
      quiet
      {...props}
    >
      <TabIcon iconName="calendar" />
      <TabText>{tabText}</TabText>
      <TabRightChild>
        <CardCount selected={selected} count={count} />
      </TabRightChild>
    </TabButton>
  </Tab>
);

interface CardDueNavigationProps {
  tabs: CardDueTabProps[];
}

export const TeamCardDueScrollNavigation: FunctionComponent<
  CardDueNavigationProps
> = ({ tabs, ...props }) => (
  <nav className={styles.cardDueContainer} {...props}>
    <TabSection>
      <TabList>
        {tabs.map((tab, index) => <CardDueTab key={index} {...tab} />)}
      </TabList>
    </TabSection>
  </nav>
);



// WEBPACK FOOTER //
// ./app/scripts/views/home/presentational/team-card-due-scroll-navigation.tsx